<template>
	<div
		class="g-block-divider-center-squares g-block-divider-padding"
		:class="{
			'g-block-divider-center-squares--edit': editable,
			'is-active': editable && active,
			'g-block-divider-center-squares--h5': h5,
			'g-block-divider-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-divider-center-squares__row">
			<span
				class="g-block-divider-center-squares__line"
				:style="{ background: themeColor }"
				aria-hidden="true"
			></span>
			<div class="g-block-divider-center-squares__ornament">
				<span
					class="g-block-divider-center-squares__tick"
					:style="{ background: themeColor }"
					aria-hidden="true"
				></span>
				<span
					class="g-block-divider-center-squares__square"
					:style="{ background: themeColor }"
					aria-hidden="true"
				></span>
				<span
					class="g-block-divider-center-squares__square"
					:style="{ background: themeColor }"
					aria-hidden="true"
				></span>
				<span
					class="g-block-divider-center-squares__tick"
					:style="{ background: themeColor }"
					aria-hidden="true"
				></span>
			</div>
			<span
				class="g-block-divider-center-squares__line"
				:style="{ background: themeColor }"
				aria-hidden="true"
			></span>
		</div>
	</div>
</template>

<script>
	import { dividerMixin } from '../shared/dividerMixin.js';

	export default {
		name: 'GBlockDividerCenterSquares',
		mixins: [dividerMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/dividerEditShell.less';
	@import '../shared/dividerPattern.less';

	.g-block-divider-center-squares {
		.divider-block-edit-shell();
	}

	.g-block-divider-center-squares__row {
		.divider-center-row();
	}

	.g-block-divider-center-squares__line {
		.divider-center-side-line();
	}

	.g-block-divider-center-squares__ornament {
		flex-shrink: 0;
		display: inline-flex;
		align-items: center;
		gap: 4px;
	}

	.g-block-divider-center-squares__tick {
		.divider-center-tick();
	}

	.g-block-divider-center-squares__square {
		width: 5px;
		height: 5px;
		flex-shrink: 0;
	}

	.g-block-divider-center-squares--h5 {
		.g-block-divider-center-squares__line {
			height: 0.02rem;
		}

		.g-block-divider-center-squares__ornament {
			gap: 0.08rem;
		}

		.g-block-divider-center-squares__tick {
			.divider-center-tick--h5();
		}

		.g-block-divider-center-squares__square {
			width: 0.1rem;
			height: 0.1rem;
		}
	}
</style>
